module.exports = new __parcel__URL__("wifire-commons-logo.22708cc0.png").toString();